'use client';

import _defineProperty from "/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "className", "style", "styles", "unstyled", "scrollbarSize", "vars", "type", "scrollHideDelay", "viewportProps", "viewportRef", "onScrollPositionChange", "children", "offsetScrollbars", "scrollbars", "onBottomReached", "onTopReached"],
  _excluded2 = ["children", "classNames", "styles", "scrollbarSize", "scrollHideDelay", "type", "dir", "offsetScrollbars", "viewportRef", "onScrollPositionChange", "unstyled", "variant", "viewportProps", "scrollbars", "style", "vars"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { rem } from '../../core/utils/units-converters/rem.mjs';
import '@mantine/hooks';
import { createVarsResolver } from '../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { useStyles } from '../../core/styles-api/use-styles/use-styles.mjs';
import { Box } from '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { ScrollAreaCorner } from './ScrollAreaCorner/ScrollAreaCorner.mjs';
import { ScrollAreaRoot } from './ScrollAreaRoot/ScrollAreaRoot.mjs';
import { ScrollAreaScrollbar } from './ScrollAreaScrollbar/ScrollAreaScrollbar.mjs';
import { ScrollAreaThumb } from './ScrollAreaThumb/ScrollAreaThumb.mjs';
import { ScrollAreaViewport } from './ScrollAreaViewport/ScrollAreaViewport.mjs';
import classes from './ScrollArea.module.css.mjs';
var defaultProps = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
};
var varsResolver = createVarsResolver(function (_, _ref) {
  var scrollbarSize = _ref.scrollbarSize;
  return {
    root: {
      "--scrollarea-scrollbar-size": rem(scrollbarSize)
    }
  };
});
var ScrollArea = factory(function (_props, ref) {
  var props = useProps("ScrollArea", defaultProps, _props);
  var classNames = props.classNames,
    className = props.className,
    style = props.style,
    styles = props.styles,
    unstyled = props.unstyled,
    scrollbarSize = props.scrollbarSize,
    vars = props.vars,
    type = props.type,
    scrollHideDelay = props.scrollHideDelay,
    viewportProps = props.viewportProps,
    viewportRef = props.viewportRef,
    onScrollPositionChange = props.onScrollPositionChange,
    children = props.children,
    offsetScrollbars = props.offsetScrollbars,
    scrollbars = props.scrollbars,
    onBottomReached = props.onBottomReached,
    onTopReached = props.onTopReached,
    others = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    scrollbarHovered = _useState2[0],
    setScrollbarHovered = _useState2[1];
  var getStyles = useStyles({
    name: "ScrollArea",
    props: props,
    classes: classes,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    vars: vars,
    varsResolver: varsResolver
  });
  return /* @__PURE__ */jsxs(ScrollAreaRoot, _objectSpread(_objectSpread(_objectSpread({
    type: type === "never" ? "always" : type,
    scrollHideDelay: scrollHideDelay,
    ref: ref,
    scrollbars: scrollbars
  }, getStyles("root")), others), {}, {
    children: [/* @__PURE__ */jsx(ScrollAreaViewport, _objectSpread(_objectSpread(_objectSpread({}, viewportProps), getStyles("viewport", {
      style: viewportProps === null || viewportProps === void 0 ? void 0 : viewportProps.style
    })), {}, {
      ref: viewportRef,
      "data-offset-scrollbars": offsetScrollbars === true ? "xy" : offsetScrollbars || void 0,
      "data-scrollbars": scrollbars || void 0,
      onScroll: function onScroll(e) {
        var _viewportProps$onScro;
        viewportProps === null || viewportProps === void 0 || (_viewportProps$onScro = viewportProps.onScroll) === null || _viewportProps$onScro === void 0 || _viewportProps$onScro.call(viewportProps, e);
        onScrollPositionChange === null || onScrollPositionChange === void 0 || onScrollPositionChange({
          x: e.currentTarget.scrollLeft,
          y: e.currentTarget.scrollTop
        });
        var _e$currentTarget = e.currentTarget,
          scrollTop = _e$currentTarget.scrollTop,
          scrollHeight = _e$currentTarget.scrollHeight,
          clientHeight = _e$currentTarget.clientHeight;
        if (scrollTop - (scrollHeight - clientHeight) === 0) {
          onBottomReached === null || onBottomReached === void 0 || onBottomReached();
        }
        if (scrollTop === 0) {
          onTopReached === null || onTopReached === void 0 || onTopReached();
        }
      },
      children: children
    })), (scrollbars === "xy" || scrollbars === "x") && /* @__PURE__ */jsx(ScrollAreaScrollbar, _objectSpread(_objectSpread({}, getStyles("scrollbar")), {}, {
      orientation: "horizontal",
      "data-hidden": type === "never" || void 0,
      forceMount: true,
      onMouseEnter: function onMouseEnter() {
        return setScrollbarHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setScrollbarHovered(false);
      },
      children: /* @__PURE__ */jsx(ScrollAreaThumb, _objectSpread({}, getStyles("thumb")))
    })), (scrollbars === "xy" || scrollbars === "y") && /* @__PURE__ */jsx(ScrollAreaScrollbar, _objectSpread(_objectSpread({}, getStyles("scrollbar")), {}, {
      orientation: "vertical",
      "data-hidden": type === "never" || void 0,
      forceMount: true,
      onMouseEnter: function onMouseEnter() {
        return setScrollbarHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setScrollbarHovered(false);
      },
      children: /* @__PURE__ */jsx(ScrollAreaThumb, _objectSpread({}, getStyles("thumb")))
    })), /* @__PURE__ */jsx(ScrollAreaCorner, _objectSpread(_objectSpread({}, getStyles("corner")), {}, {
      "data-hovered": scrollbarHovered || void 0,
      "data-hidden": type === "never" || void 0
    }))]
  }));
});
ScrollArea.displayName = "@mantine/core/ScrollArea";
var ScrollAreaAutosize = factory(function (props, ref) {
  var _useProps = useProps("ScrollAreaAutosize", defaultProps, props),
    children = _useProps.children,
    classNames = _useProps.classNames,
    styles = _useProps.styles,
    scrollbarSize = _useProps.scrollbarSize,
    scrollHideDelay = _useProps.scrollHideDelay,
    type = _useProps.type,
    dir = _useProps.dir,
    offsetScrollbars = _useProps.offsetScrollbars,
    viewportRef = _useProps.viewportRef,
    onScrollPositionChange = _useProps.onScrollPositionChange,
    unstyled = _useProps.unstyled,
    variant = _useProps.variant,
    viewportProps = _useProps.viewportProps,
    scrollbars = _useProps.scrollbars,
    style = _useProps.style,
    vars = _useProps.vars,
    others = _objectWithoutProperties(_useProps, _excluded2);
  return /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread({}, others), {}, {
    ref: ref,
    style: [{
      display: "flex",
      overflow: "auto"
    }, style],
    children: /* @__PURE__ */jsx(Box, {
      style: {
        display: "flex",
        flexDirection: "column",
        flex: 1
      },
      children: /* @__PURE__ */jsx(ScrollArea, {
        classNames: classNames,
        styles: styles,
        scrollHideDelay: scrollHideDelay,
        scrollbarSize: scrollbarSize,
        type: type,
        dir: dir,
        offsetScrollbars: offsetScrollbars,
        viewportRef: viewportRef,
        onScrollPositionChange: onScrollPositionChange,
        unstyled: unstyled,
        variant: variant,
        viewportProps: viewportProps,
        vars: vars,
        scrollbars: scrollbars,
        children: children
      })
    })
  }));
});
ScrollArea.classes = classes;
ScrollAreaAutosize.displayName = "@mantine/core/ScrollAreaAutosize";
ScrollAreaAutosize.classes = classes;
ScrollArea.Autosize = ScrollAreaAutosize;
export { ScrollArea, ScrollAreaAutosize };